export default __webpack_public_path__ + "static/media/sentiment_neutral.d980f733.svg";